import type { TAgreementType } from "./licensing";

export const sourceToAgreementTypeMap: Record<string, TAgreementType> = {
  "CME NYMEX": "CME_NYMEX",
  "ICE FUTURES EUROPE": "ICE_FUTURES_EUROPE",
  "ICE FUTURES ABU DHABI": "ICE_FUTURES_ABU_DHABI",
  "ICE ENDEX": "ICE_ENDEX",
  IDS: "IDS",
  tpicapXC: "TP_ICAP",
  artisXC: "ARTIS_XC",
  ARTIS: "ARTIS",
  SGX: "SGX",
  "Singapore Exchange": "SGX",
  ZCE: "ZCE",
  "Zhengzhou Commodity Exchange": "ZCE",
};

type UsageRow = { source?: number | null; event?: string | null };
type SourceRow = { id: number; name?: string | null };

type Usage = ReadonlyArray<UsageRow> | null | undefined;
type Sources = ReadonlyArray<SourceRow> | null | undefined;

const pendingSourceIds = (usage: Usage): number[] =>
  usage?.flatMap((u) => (u.event === "pending" && u.source != null ? [u.source] : [])) ?? [];

export function getPendingLicenceAgreements(
  usage: Usage,
  sources: Sources,
): Array<{ name: TAgreementType; sourceId: number }> {
  const nameById = new Map(sources?.map((s) => [s.id, s.name]) ?? []);

  return pendingSourceIds(usage).flatMap((sourceId) => {
    const name = nameById.get(sourceId);
    const agreementType = name ? sourceToAgreementTypeMap[name] : undefined;
    return agreementType ? [{ name: agreementType, sourceId }] : [];
  });
}

// Pending agreements we can't identify yet because the source list doesn't contain the id. An empty
// source list means it hasn't loaded, which is not the same as the id being absent from it, so those
// ids are not reported as unresolved.
export function unresolvedPendingSourceIds(usage: Usage, sources: Sources): number[] {
  if (!sources) return [];

  const knownIds = new Set(sources.map((s) => s.id));
  return [...new Set(pendingSourceIds(usage).filter((id) => !knownIds.has(id)))].sort((a, b) => a - b);
}
